export const API_BASE_URL = 'https://aplexia.com/api';
// export const API_BASE_URL = 'http://192.168.1.241:8000/api';
